import React, {ReactElement, useEffect, useRef} from 'react';

type TProps = {
  element: HTMLElement;
};

const Reparentable = ({element}: TProps): ReactElement => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.appendChild(element);
  }, [element]);

  return <div className="flex min-h-full w-full" ref={ref} />;
};

export default Reparentable;
